import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNTreatment } from 'src/app/models/cntreatment';
import { PrescriptionDialogComponent } from '../../prescription/prescription-dialog/prescription-dialog.component';

@ManageType('TreatmentDialogComponent')
@Component({
  selector: 'app-treatment-dialog',
  templateUrl: './treatment-dialog.component.html',
  styleUrls: ['./treatment-dialog.component.scss']
})
export class TreatmentDialogComponent implements OnInit {

  public treatment: CNTreatment;

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<PrescriptionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data && data.treatment) {
      this.treatment = data.treatment;
    }
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(this.treatment);
  }
}
